export default __webpack_public_path__ + "static/media/인천.15524ae5.png";